import { createStore } from '@stencil/store';

const initialState = {
  hasDataObject: false,
  hasManualBoost: false,
  shouldDisplay: false,

  confirmedDate: '',
  amount: undefined as number,
  isSubmitting: false,

  inputAmount: undefined as number,
  currentStep: 0,
  error: '',
  message: '',
};

const { on, onChange, state, reset } = createStore(initialState);
type CounterofferState = typeof initialState;

export { initialState, on, onChange, reset, state, CounterofferState };
export default state;
